import { render, staticRenderFns } from "./CardUpdate.vue?vue&type=template&id=37cdb08a"
import script from "./CardUpdate.vue?vue&type=script&lang=js"
export * from "./CardUpdate.vue?vue&type=script&lang=js"
import style0 from "./CardUpdate.vue?vue&type=style&index=0&id=37cdb08a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cdb08a')) {
      api.createRecord('37cdb08a', component.options)
    } else {
      api.reload('37cdb08a', component.options)
    }
    module.hot.accept("./CardUpdate.vue?vue&type=template&id=37cdb08a", function () {
      api.rerender('37cdb08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/CardUpdate.vue"
export default component.exports